<template>
  <vue-countdown ref="countdownRef" v-slot="{ days, hours, minutes, seconds }" :time="time" @progress="progressHandler">
    <template v-if="BigNumber(days).isGreaterThan(0)">
      {{ Formatters.text.zeroPrefix(days) + t('coreDaysPostfix') }}
      {{ BigNumber(hours).isGreaterThan(0) ? Formatters.text.zeroPrefix(hours) + t('coreHoursPostfix') : '' }}
    </template>

    <template v-else-if="BigNumber(hours).isGreaterThan(0)">
      {{ Formatters.text.zeroPrefix(hours) + t('coreHoursPostfix') }}
      {{ BigNumber(minutes).isGreaterThan(0) ? Formatters.text.zeroPrefix(minutes) + t('coreMinPostfix') : '' }}
    </template>

    <template v-else-if="BigNumber(minutes).isGreaterThan(0)">
      {{ Formatters.text.zeroPrefix(minutes) + t('coreMinPostfix') }}
      {{ BigNumber(seconds).isGreaterThan(0) ? Formatters.text.zeroPrefix(seconds) + t('coreSecPostfix') : '' }}
    </template>

    <template v-else>
      {{ Formatters.text.zeroPrefix(seconds) + t('coreSecPostfix') }}
    </template>
  </vue-countdown>
</template>
<script setup lang="ts">
import { BigNumber } from 'bignumber.js';
import VueCountdown from '@chenfengyuan/vue-countdown';
import { Formatters } from '~/utils/formatters/formatters';
const { t } = useI18n();

defineProps<{
  time: number;
}>();

const { data: runningRecipes } = useNuxtData('recipes/in-queue');
const setQueueTimeInjected = inject<(value: number) => void>('setQueueTime');

const progressHandler = ({ totalMilliseconds }: { totalMilliseconds: number }) => {
  const queueTime = runningRecipes.value && runningRecipes.value.length > 0 ? totalMilliseconds : 0;
  setQueueTimeInjected && setQueueTimeInjected(queueTime);
};
</script>
